import React from "react";
import "./Portfolio.css";
// video
import anmeEmge from "../../projectsEmges/anime.png";
import portfolio from "../../projectsEmges/portfolio.png";
import bookslibrary from "../../projectsEmges/bookslibrary.png";
import burgerHuse from "../../projectsEmges/burgerHuse.png";
import skygalaxy from "../../projectsEmges/skygalaxy.png";
import tafesh from "../../projectsEmges/tafesh.png";
import mohapainting from "../../projectsEmges/painting.png";
import ohya from "../../projectsEmges/ohaya.png";
import afia from "../../projectsEmges/afia.png";
// reveal
import { Fade } from "react-awesome-reveal";

export default function Portfolio() {
const projectData = [
  {
    src: tafesh,
    title: "E-Commerce Website (WordPress & WooCommerce)",
    animation: "left",
    href: "https://tafesh.com",
  },
  {
    src: skygalaxy,
    title: "Online Store (React, Express & MongoDB)",
    animation: "right",
    href: "https://skygalaxy.shop",
  },
  {
    src: mohapainting,
    title: "Landing Page (WordPress)",
    animation: "right",
    href: "https://mohapainting.com/",
  },
  {
    src: ohya,
    title: "Landing Page (HTML, CSS & JavaScript)",
    animation: "right",
    href: "https://ohayadekora.com/",
  },
  {
    src: afia,
    title: "Admin Dashboard (React & Laravel)",
    animation: "right",
    href: "https://afia-react.onrender.com/",
  },
  {
    src: burgerHuse,
    title: "Restaurant Website (React, HTML & CSS)",
    animation: "right",
    href: "https://fantastic-cascaron-57ee21.netlify.app/",
  },
  {
    src: portfolio,
    title: "Portfolio Website (HTML, CSS, JS & jQuery)",
    animation: "bottom",
    href: "https://reliable-kheer-bca126.netlify.app/",
  },
  {
    src: bookslibrary,
    title: "Books Library App (HTML, CSS, JS & jQuery)",
    animation: "bottom",
    href: "https://deluxe-cobbler-af72a9.netlify.app/login.html",
  },
  {
    src: anmeEmge,
    title: "Anime Gallery (HTML, CSS, JS & jQuery)",
    animation: "bottom",
    href: "https://65ff37bcddc42d4746dace62--zesty-kringle-099d59.netlify.app/",
  },
];


  return (
    <div id="section6">
      <div id="container">
        {projectData.map((e, index) => {
          return (
            <Fade
              direction={e.animation}
              cascade
              triggerOnce={true}
              key={index}
            >
              <div id="project">
                {/* <video controls preload='metadata' width="100%" height="auto"src={e.src} >
                  Your browser does not support the video tag.
                  </video> */}
                <img src={e.src} alt="" />
                <span>{e.title}</span>

                <a rel="noreferrer" target="_blank" href={e.href}>
                  live peview
                </a>
              </div>
            </Fade>
          );
        })}
      </div>
    </div>
  );
}
